import {base64StringToBlob} from "blob-util";
import {ApiFileResponse} from "../model/api/api-file-response";

export class FileUtils {

  static download(apiFileResponse: ApiFileResponse) {

    const data: Blob = base64StringToBlob(apiFileResponse.item, apiFileResponse.contentType);
    const blobUrl = URL.createObjectURL(data);
    // const source = base64StringBlob;//'data:' + contentType + ',' + base64StringBlob;
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = apiFileResponse.fileName;
    link.click();
  }

}
